declare global {
    interface Window {
        porterbuddy: {
            token: string;
            view: string;
        };
    }
}

export default function showPorterbuddyWidget() {
    const addToCartFormComponent = document.querySelector(
        ".add-to-cart-form-component",
    );
    const mobileContainer = document.querySelector(".pb-mobile-container");
    const desktopContainer = document.querySelector(".pb-desktop-container");

    if (!addToCartFormComponent || !mobileContainer || !desktopContainer) {
        return;
    }

    const isMobile = () => window.innerWidth < 768;

    const porterbuddyWidget = document.querySelector(
        "#porterbuddy-widget",
    ) as HTMLElement;

    if (!porterbuddyWidget) {
        return;
    }

    window.porterbuddy = {
        token: porterbuddyWidget.dataset.pbToken || "",
        view: porterbuddyWidget.dataset.pbView || "availability",
    };

    const placeWidget = () => {
        if (isMobile()) {
            if (!mobileContainer.contains(porterbuddyWidget)) {
                if (porterbuddyWidget.parentElement) {
                    porterbuddyWidget.parentElement.removeChild(
                        porterbuddyWidget,
                    );
                }
                mobileContainer.appendChild(porterbuddyWidget);
            }
        } else {
            if (!desktopContainer.contains(porterbuddyWidget)) {
                if (porterbuddyWidget.parentElement) {
                    porterbuddyWidget.parentElement.removeChild(
                        porterbuddyWidget,
                    );
                }
                desktopContainer.appendChild(porterbuddyWidget);
            }
        }
    };

    placeWidget();

    // Reinsert on resize
    window.addEventListener("resize", placeWidget);
}